// extracted by mini-css-extract-plugin
module.exports = {"newSequence":"WebUITests_newSequence__j9IjA","sequence":"WebUITests_sequence__27rx_","sequenceStep":"WebUITests_sequenceStep__1wne-","flex":"WebUITests_flex__31OF1"};